(function(){
    'use strict';
    angular.module('ib-MmB-change-flights-service',[]);
})();